import { render, staticRenderFns } from "./LineItem2.vue?vue&type=template&id=4e0e9850&scoped=true&"
import script from "./LineItem2.vue?vue&type=script&lang=js&"
export * from "./LineItem2.vue?vue&type=script&lang=js&"
import style0 from "./LineItem2.vue?vue&type=style&index=0&id=4e0e9850&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e0e9850",
  null
  
)

export default component.exports